// src/utils.ts - ESLint compliant version with enhanced formatting
// import type { Contact } from './types';

export const getInitials = (firstName?: string, lastName?: string): string => {
  const safeFirst = typeof firstName === 'string' ? firstName.trim() : '';
  const safeLast = typeof lastName === 'string' ? lastName.trim() : '';
  const first = safeFirst.charAt(0).toUpperCase() || '';
  const last = safeLast.charAt(0).toUpperCase() || '';
  return (first + last) || '?';
};

export const formatDate = (dateString?: string): string => {
  if (!dateString || typeof dateString !== 'string') return 'Unknown';
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'Invalid date';
    return date.toLocaleDateString();
  } catch {
    return 'Invalid date';
  }
};

export const formatLargeNumber = (num: number): string => {
  if (num >= 1_000_000_000) return `${(num / 1_000_000_000).toFixed(2).replace(/\.?0+$/, '')}B`;
  if (num >= 1_000_000) return `${(num / 1_000_000).toFixed(1).replace(/\.?0+$/, '')}M`;
  if (num >= 1_000) return `${(num / 1_000).toFixed(1).replace(/\.?0+$/, '')}K`;
  return num.toLocaleString();
};

export const formatTime = (ms: number): string => {
  if (ms >= 1000) return `${(ms / 1000).toFixed(1)}s`;
  return `${ms}ms`;
};

export interface ValidationStatus {
  text: string;
  className: string;
}

export const getValidationStatus = (status?: string | null): ValidationStatus => {
  if (!status || typeof status !== 'string') return { text: 'Unverified', className: 'status-unverified' };
  const normalizedStatus = status.toLowerCase().trim();
  if (normalizedStatus === 'valid' || normalizedStatus === 'verified') return { text: 'Verified', className: 'status-verified' };
  else if (normalizedStatus === 'invalid') return { text: 'Invalid', className: 'status-invalid' };
  return { text: 'Unverified', className: 'status-unverified' };
};

export const generateId = (): string => {
  return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
};